import { Brand, createBranded } from '@deltasierra/type-utilities';

export type SanitizedFileName = Brand<string, 'SanitizedFileName'>;
export const SanitizedFileName = createBranded<SanitizedFileName>();
